import React from 'react';
import { NoModuleRights } from '../../utils/utils';

const UserSideMenu = ({ subCategory, setSubCategory,setRoleEditID,setRoleName }) => {
    
    return (
        <div className="leftlang-box">
            <div className="user-ul">
                <ul>
                    {!NoModuleRights('Users') && <li onClick={() => setSubCategory("user")}>
                        <p className={`user-link ${subCategory === "user" ? "active" : ""}`}>
                            User
                        </p>
                    </li>}
                    {/* <li>
                        <p className="user-link">
                            Group Management
                        </p>
                    </li> */}
                    {!NoModuleRights('Roles') && <li onClick={() => {setSubCategory("roleManagement"); setRoleEditID(""); setRoleName("");}}>
                        <p className={`user-link ${subCategory === "roleManagement" || subCategory === "add_role" ? "active" : ""}`}>
                            Role Management
                        </p>
                    </li>}
                    {/* <li>
                        <p className="user-link">
                            User Suggestions
                        </p>
                    </li> */}
                </ul>
            </div>
        </div>
    )
}

export default UserSideMenu;
